import type { RuleSet } from './types.js';
import { RUSSIAN_SHASHKI } from './russian.js';
import { ENGLISH_DRAUGHTS } from './english.js';

export type VariantId = 'russian' | 'english';

export const VARIANTS: Record<VariantId, RuleSet> = {
  russian: RUSSIAN_SHASHKI,
  english: ENGLISH_DRAUGHTS,
};

const VARIANT_IDS = Object.keys(VARIANTS) as readonly VariantId[];

export function isVariantId(value: unknown): value is VariantId {
  return typeof value === 'string' && (VARIANT_IDS as readonly string[]).includes(value);
}

export function getRuleSet(id: VariantId): RuleSet {
  return VARIANTS[id];
}

export { RUSSIAN_SHASHKI, ENGLISH_DRAUGHTS };
export type { RuleSet };
